@if (maintenance) {
  <div class="maintenance-container">
    <div class="maintenance-message-container">
      <div class="maintenance-title">
        {{'maintenance.title' | translate}}
      </div>
      <div class="maintenance-message">
        {{'maintenance.message' | translate}}
      </div>
    </div>
  </div>
}
@if (!maintenance) {
  <div id="global" class="global-container">
    @if (isloggedIn) {
      <div>
        <div class="app-left-navigation" (mouseover)="fullSidebar = true" (mouseout)="fullSidebar = false" [class.extended]="fullSidebar" [fullSidebar]="fullSidebar"></div>
      </div>
    }
    @if (isloggedIn) {
      <div [ngClass]="!fullSidebar ? 'right-content--extended' : 'right-content'">
        <router-outlet></router-outlet>
        @if (currentUrlSlug === 'login' || currentUrlSlug === 'implicit' || currentUrlSlug === 'error-page' || currentUrlSlug === 'logged-in-callback') {
          <div id="wrap-main" class="global-subelement-container"
            >
            <!-- Routed components go here, all hidden when user is not authenticated except the login page-->
            <div id="main">
              <div id="main-content">
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="notLogged">
        <router-outlet></router-outlet>
      </div>
    }
    @if (displayNotification$ | async) {
      <div id="alert-container" [ngClass]="(displayNotification$ | async) ? 'show-alert': 'alert-hidden'">
        <app-alert></app-alert>
      </div>
    }
    @if (displayNotification$ | async) {
      <div id="alert-overlay"></div>
    }
  </div>
}
